import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import LoginForm from '../views/LoginForm.vue'
import Main from '../components/Main.vue'
// import OAuthCallback from '../components/login/OAuthCallback.vue'
import { useUserProfileStore } from '../stores/userProfileStore'
import { useAppStore } from '../stores/appStore'
import { LoginRequired } from '../types/app/loginRequired'
import OAuthCallback from '../components/login/OAuthCallback.vue'
import LoginFailed from '../views/LoginFailed.vue'
import { loadAndSetLocale } from '../i18n'
import type { RouteLocationNormalized } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'main',
    component: Main,
  },
  {
    path: '/login',
    name: 'login',
    component: LoginForm,
  },
  {
    path: '/login/callback',
    name: 'oauthCallback',
    component: OAuthCallback,
  },
  {
    path: '/loginfailed',
    name: 'loginFailed',
    component: LoginFailed,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

async function applyUrlPreferences(to: RouteLocationNormalized) {
  const appStore = useAppStore()
  const configuration = appStore.configuration

  if (!configuration) {
    return
  }

  const productEnabled = !!configuration.components.productFromUrl?.enabled
  const availableProducts = configuration.components.productSelect.availableProducts ?? []
  const productQuery = typeof to.query.product === 'string' ? to.query.product : ''

  if (productEnabled && productQuery && availableProducts.includes(productQuery)) {
    appStore.setProductFromUrl(productQuery)
  }

  const languageEnabled = !!configuration.components.languageFromUrl?.enabled
  const languageQuery = typeof to.query.lang === 'string' ? to.query.lang : ''
  const normalizedLanguageQuery = languageQuery.toLowerCase()
  const availableLanguages = configuration.languages.map(lang => lang.fileName)

  if (!languageEnabled || !normalizedLanguageQuery) {
    return
  }

  if (!availableLanguages.includes(normalizedLanguageQuery)) {
    console.log(`No such language or translation unavailable for lang parameter: ${languageQuery}`)
    return
  }

  const languageApplied = await loadAndSetLocale(normalizedLanguageQuery)
  if (!languageApplied) {
    console.log(`No such language or translation unavailable for lang parameter: ${languageQuery}`)
    return
  }

  appStore.setLanguage(normalizedLanguageQuery)
}

router.beforeEach(async to => {
  const appStore = useAppStore()
  const userProfileStore = useUserProfileStore()
  const loginRequired = appStore.configuration?.login.isLoginRequired
  const isUserLoggedIn = userProfileStore.isLoggedIn

  await applyUrlPreferences(to)

  const productFromUrl = appStore.productFromUrl ?? ''
  const shouldAppendProduct =
    to.name === 'main' &&
    !!appStore.configuration?.components.productFromUrl?.enabled &&
    !!appStore.productFromUrl &&
    appStore.configuration.components.productSelect.availableProducts.includes(productFromUrl) &&
    to.query.product !== productFromUrl

  console.log(`Router: ${loginRequired}, user: ${isUserLoggedIn}`)

  if (loginRequired === LoginRequired.Always && !isUserLoggedIn && to.name == 'main') {
    return {
      name: 'login',
    }
  }

  if (loginRequired === LoginRequired.Never && to.name == 'login') {
    return {
      name: 'main',
      query: productFromUrl ? { product: productFromUrl } : undefined,
    }
  }

  if (loginRequired === LoginRequired.Never && to.name == 'main') {
    return
  }

  if (shouldAppendProduct) {
    return {
      name: 'main',
      query: {
        ...to.query,
        product: productFromUrl,
      },
    }
  }
})

export default router
